import PaymentTypeManager from 'app/src/payments/PaymentTypeManager';
import PendingPayment from 'app/src/payments/PendingPayment';

/**
 * Class definition for a cash payment
 */
export default class CashPayment extends PendingPayment {
  /**
   * Constructor
   * @param amount {Decimal}  The amount of the cash payment
   * @param saleID {Number}   The ID of the sale for the payment
   */
  constructor(amount, saleID = 0) {
    super(amount, PaymentTypeManager.getPaymentIdForType(PaymentTypeManager.Types.CASH), saleID);

    this._allowMultiple = false;
  }
}
